import { CountryCode } from 'libphonenumber-js';
import { AppLocale } from 'src/models/modules';

export interface ICountryCode {
    value: CountryCode;
    text: string;
}

const enCountryCode: ICountryCode = { value: 'US', text: '+1(US)' };
const huCountryCode: ICountryCode = { value: 'HU', text: '+36' };
const skCountryCode: ICountryCode = { value: 'SK', text: '+421' };
const deCountryCode: ICountryCode = { value: 'DE', text: '+49' };

export const defaultCountryCodes = {
    [AppLocale.Hu]: huCountryCode,
    [AppLocale.De]: deCountryCode,
    [AppLocale.Sk]: skCountryCode,
    [AppLocale.En]: enCountryCode
}

export const countryCodes: ICountryCode[] = [
    enCountryCode,
    { value: 'CA', text: '+1(CA)' },
    { value: 'RU', text: '+7' },
    { value: 'EG', text: '+20' },
    { value: 'ZA', text: '+27' },
    { value: 'GR', text: '+30' },
    { value: 'NL', text: '+31' },
    { value: 'BE', text: '+32' },
    { value: 'FR', text: '+33' },
    { value: 'ES', text: '+34' },
    huCountryCode,
    { value: 'IT', text: '+39' },
    { value: 'RO', text: '+40' },
    { value: 'CH', text: '+41' },
    { value: 'AT', text: '+43' },
    { value: 'GB', text: '+44' },
    { value: 'DK', text: '+45' },
    { value: 'SE', text: '+46' },
    { value: 'NO', text: '+47' },
    { value: 'PL', text: '+48' },
    deCountryCode,
    { value: 'PE', text: '+51' },
    { value: 'MX', text: '+52' },
    { value: 'CU', text: '+53' },
    { value: 'AR', text: '+54' },
    { value: 'BR', text: '+55' },
    { value: 'CL', text: '+56' },
    { value: 'CO', text: '+57' },
    { value: 'VE', text: '+58' },
    { value: 'MY', text: '+60' },
    { value: 'AU', text: '+61' },
    { value: 'ID', text: '+62' },
    { value: 'PH', text: '+63' },
    { value: 'NZ', text: '+64' },
    { value: 'SG', text: '+65' },
    { value: 'TH', text: '+66' },
    { value: 'KZ', text: '+76' },
    { value: 'KZ', text: '+77' },
    { value: 'JP', text: '+81' },
    { value: 'KR', text: '+82' },
    { value: 'VN', text: '+84' },
    { value: 'CN', text: '+86' },
    { value: 'TR', text: '+90' },
    { value: 'IN', text: '+91' },
    { value: 'PK', text: '+92' },
    { value: 'AF', text: '+93' },
    { value: 'LK', text: '+94' },
    { value: 'MM', text: '+95' },
    { value: 'IR', text: '+98' },
    { value: 'SS', text: '+211' },
    { value: 'MA', text: '+212' },
    { value: 'DZ', text: '+213' },
    { value: 'TN', text: '+216' },
    { value: 'LY', text: '+218' },
    { value: 'GM', text: '+220' },
    { value: 'SN', text: '+221' },
    { value: 'MR', text: '+222' },
    { value: 'ML', text: '+223' },
    { value: 'GN', text: '+224' },
    { value: 'CI', text: '+225' },
    { value: 'BF', text: '+226' },
    { value: 'NE', text: '+227' },
    { value: 'TG', text: '+228' },
    { value: 'BJ', text: '+229' },
    { value: 'MU', text: '+230' },
    { value: 'LR', text: '+231' },
    { value: 'SL', text: '+232' },
    { value: 'GH', text: '+233' },
    { value: 'NG', text: '+234' },
    { value: 'TD', text: '+235' },
    { value: 'CF', text: '+236' },
    { value: 'CM', text: '+237' },
    { value: 'CV', text: '+238' },
    { value: 'ST', text: '+239' },
    { value: 'GQ', text: '+240' },
    { value: 'GA', text: '+241' },
    { value: 'CG', text: '+242' },
    { value: 'CD', text: '+243' },
    { value: 'AO', text: '+244' },
    { value: 'GW', text: '+245' },
    { value: 'IO', text: '+246' },
    { value: 'SH', text: '+247' },
    { value: 'SC', text: '+248' },
    { value: 'SD', text: '+249' },
    { value: 'RW', text: '+250' },
    { value: 'ET', text: '+251' },
    { value: 'SO', text: '+252' },
    { value: 'DJ', text: '+253' },
    { value: 'KE', text: '+254' },
    { value: 'TZ', text: '+255' },
    { value: 'UG', text: '+256' },
    { value: 'BI', text: '+257' },
    { value: 'MZ', text: '+258' },
    { value: 'ZM', text: '+260' },
    { value: 'MG', text: '+261' },
    { value: 'YT', text: '+262' },
    { value: 'ZW', text: '+263' },
    { value: 'NA', text: '+264' },
    { value: 'MW', text: '+265' },
    { value: 'LS', text: '+266' },
    { value: 'BW', text: '+267' },
    { value: 'SZ', text: '+268' },
    { value: 'KM', text: '+269' },
    { value: 'SH', text: '+290' },
    { value: 'ER', text: '+291' },
    { value: 'AW', text: '+297' },
    { value: 'FO', text: '+298' },
    { value: 'GL', text: '+299' },
    { value: 'GI', text: '+350' },
    { value: 'PT', text: '+351' },
    { value: 'LU', text: '+352' },
    { value: 'IE', text: '+353' },
    { value: 'IS', text: '+354' },
    { value: 'AL', text: '+355' },
    { value: 'MT', text: '+356' },
    { value: 'CY', text: '+357' },
    { value: 'FI', text: '+358' },
    { value: 'BG', text: '+359' },
    { value: 'LT', text: '+370' },
    { value: 'LV', text: '+371' },
    { value: 'EE', text: '+372' },
    { value: 'MD', text: '+373' },
    { value: 'AM', text: '+374' },
    { value: 'BY', text: '+375' },
    { value: 'AD', text: '+376' },
    { value: 'MC', text: '+377' },
    { value: 'SM', text: '+378' },
    { value: 'VA', text: '+379' },
    { value: 'UA', text: '+380' },
    { value: 'RS', text: '+381' },
    { value: 'ME', text: '+382' },
    { value: 'HR', text: '+385' },
    { value: 'SI', text: '+386' },
    { value: 'BA', text: '+387' },
    { value: 'MK', text: '+389' },
    { value: 'CZ', text: '+420' },
    skCountryCode,
    { value: 'LI', text: '+423' },
    { value: 'FK', text: '+500' },
    { value: 'BZ', text: '+501' },
    { value: 'GT', text: '+502' },
    { value: 'SV', text: '+503' },
    { value: 'HN', text: '+504' },
    { value: 'NI', text: '+506' },
    { value: 'CR', text: '+506' },
    { value: 'PA', text: '+507' },
    { value: 'PM', text: '+508' },
    { value: 'HT', text: '+509' },
    { value: 'BL', text: '+590' },
    { value: 'BO', text: '+591' },
    { value: 'GY', text: '+592' },
    { value: 'EC', text: '+593' },
    { value: 'GF', text: '+594' },
    { value: 'PY', text: '+595' },
    { value: 'MQ', text: '+596' },
    { value: 'SR', text: '+597' },
    { value: 'UY', text: '+598' },
    { value: 'TL', text: '+670' },
    { value: 'NF', text: '+672' },
    { value: 'BN', text: '+673' },
    { value: 'NR', text: '+674' },
    { value: 'PG', text: '+675' },
    { value: 'TO', text: '+676' },
    { value: 'SB', text: '+677' },
    { value: 'VU', text: '+678' },
    { value: 'FJ', text: '+679' },
    { value: 'PW', text: '+680' },
    { value: 'WF', text: '+681' },
    { value: 'CK', text: '+682' },
    { value: 'NU', text: '+683' },
    { value: 'WS', text: '+685' },
    { value: 'KI', text: '+686' },
    { value: 'NC', text: '+687' },
    { value: 'TV', text: '+688' },
    { value: 'PF', text: '+689' },
    { value: 'TK', text: '+690' },
    { value: 'FM', text: '+691' },
    { value: 'MH', text: '+692' },
    { value: 'KP', text: '+850' },
    { value: 'HK', text: '+852' },
    { value: 'MO', text: '+853' },
    { value: 'KH', text: '+855' },
    { value: 'LA', text: '+856' },
    { value: 'BD', text: '+880' },
    { value: 'TW', text: '+886' },
    { value: 'MV', text: '+960' },
    { value: 'LB', text: '+961' },
    { value: 'JO', text: '+962' },
    { value: 'SY', text: '+963' },
    { value: 'IQ', text: '+964' },
    { value: 'KW', text: '+965' },
    { value: 'SA', text: '+966' },
    { value: 'YE', text: '+967' },
    { value: 'OM', text: '+968' },
    { value: 'PS', text: '+970' },
    { value: 'AE', text: '+971' },
    { value: 'IL', text: '+972' },
    { value: 'BH', text: '+973' },
    { value: 'QA', text: '+974' },
    { value: 'BT', text: '+975' },
    { value: 'MN', text: '+976' },
    { value: 'NP', text: '+977' },
    { value: 'TJ', text: '+992' },
    { value: 'TM', text: '+993' },
    { value: 'AZ', text: '+994' },
    { value: 'GE', text: '+995' },
    { value: 'KG', text: '+996' },
    { value: 'UZ', text: '+998' },
    { value: 'BS', text: '+1242' },
    { value: 'BB', text: '+1246' },
    { value: 'AI', text: '+1264' },
    { value: 'AG', text: '+1268' },
    { value: 'VG', text: '+1284' },
    { value: 'VI', text: '+1340' },
    { value: 'KY', text: '+1345' },
    { value: 'BM', text: '+1441' },
    { value: 'GD', text: '+1473' },
    { value: 'TC', text: '+1649' },
    { value: 'MS', text: '+1664' },
    { value: 'MP', text: '+1670' },
    { value: 'GU', text: '+1671' },
    { value: 'AS', text: '+1684' },
    { value: 'SX', text: '+1721' },
    { value: 'LC', text: '+1758' },
    { value: 'DM', text: '+1767' },
    { value: 'VC', text: '+1784' },
    { value: 'PR', text: '+1787' },
    { value: 'DO', text: '+1809' },
    { value: 'TT', text: '+1868' },
    { value: 'KN', text: '+1869' },
    { value: 'JM', text: '+1876' }
]